
import SettingsTabs from "@/components/settings/SettingsTabs";

export default function Settings() {
  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Configurações</h1>
      </div>

      <SettingsTabs />

    </>
  );
}
